var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-all",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.808824, 0.000000)",
    fill: "#212529",
    fillRule: "nonzero",
    id: "\\uF069"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1599265,11.15625 C14.3890931,11.28125 14.4411765,11.4583333 14.3161765,11.6875 L13.9411765,12.3125 C13.8161765,12.5416667 13.6390931,12.59375 13.4099265,12.46875 L7.94117647,9.3125 L7.94117647,15.625 C7.94117647,15.875 7.81617647,16 7.56617647,16 L6.81617647,16 C6.56617647,16 6.44117647,15.875 6.44117647,15.625 L6.44117647,9.3125 L0.972426471,12.46875 C0.743259804,12.59375 0.566176471,12.5416667 0.441176471,12.3125 L0.0661764706,11.6875 C-0.0588235294,11.4583333 -0.00674019608,11.28125 0.222426471,11.15625 L5.69117647,8 L0.222426471,4.84375 C-0.00674019608,4.71875 -0.0588235294,4.54166667 0.0661764706,4.3125 L0.441176471,3.6875 C0.566176471,3.45833333 0.743259804,3.40625 0.972426471,3.53125 L6.44117647,6.6875 L6.44117647,0.375 C6.44117647,0.125 6.56617647,0 6.81617647,0 L7.56617647,0 C7.81617647,0 7.94117647,0.125 7.94117647,0.375 L7.94117647,6.6875 L13.4099265,3.53125 C13.6390931,3.40625 13.8161765,3.45833333 13.9411765,3.6875 L14.3161765,4.3125 C14.4411765,4.54166667 14.3890931,4.71875 14.1599265,4.84375 L8.69117647,8 L14.1599265,11.15625 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAll);
export default __webpack_public_path__ + "static/media/icon-all.3f8522aac99daadcd3051bbdb3adf130.svg";
export { ForwardRef as ReactComponent };